import { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { Modal, Button } from "antd";
import { fetchAgreementBySlug } from "../../apis/agreementsApi";
import QRCode from "qrcode.react"; // npm install qrcode.react
import { useAuth } from "../../components/AuthProvider";
import apiClient from "../../apis/ApiInterceptor";
import { useLoading } from "../../components/LoadingContext";

const Agreement = () => {
  const { slug } = useParams();
  const location = useLocation();
  const [agreement, setAgreement] = useState(location.state?.agreement || null);
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const { authenticatedUser } = useAuth();
  const [hasPlan, setHasPlan] = useState(false);

  const { setLoading } = useLoading();
  

  useEffect(() => {
    const loadUserPlans = async () => {
      setLoading(true);
      const response = await apiClient.get(`/users/${authenticatedUser}/plans`); // TODO: move this to api
      setHasPlan(response.data && response.data.length > 0);
      setLoading(false);
    };
    loadUserPlans();
  }, [authenticatedUser]);

  useEffect(() => {
    if (!agreement && slug) {
      setLoading(true);
      fetchAgreementBySlug(slug)
        .then(res => setAgreement(res.data))
        .catch(() => setAgreement(null))
        .finally(() => setLoading(false));
    }
  }, [slug, agreement]);

  const showPdf = () => {
    setPdfUrl(`/pdf/${agreement.terms_and_conditions}`);
    setPdfModalVisible(true);
  };

  if (!agreement) {
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <p>No se encontró el convenio.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 340, margin: "40px auto", textAlign: "center" }}>
      <img
        src={`/img/agreements/${agreement.img}`}
        alt={agreement.name}
        style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 16, marginBottom: 24 }}
      />
      <h2 style={{ marginBottom: 12 }}>{agreement.name}</h2>
      <p className="mb-2">{agreement.description}</p>
      <div style={{ fontSize: 28, fontWeight: 600, marginBottom: 16 }}>
        {agreement.percentage_offer
          ? `* ${agreement.percentage_offer}% OFF`
          : agreement.discounted_amount
          ? `* ${agreement.discounted_amount} OFF`
          : null}
      </div>
      {hasPlan ? (
        <div style={{ margin: "24px 0" }}>
          <p className="mb-2">Muestra este QR en el comercio aliado</p>
          <QRCode value={`${window.location.origin}/agreements/${agreement.slug}/users/${authenticatedUser}`} size={180} />
        </div>
      ) :
      (
        <div style={{ margin: "24px 0" }}>
          <p style={{ color: "red", marginBottom: 24 }}>
            Debes tener un plan activo para acceder a este convenio.
          </p>
          <button type="button" className="btn btn-success">
            <Link to="/plans">Ver Planes</Link>
          </button>
        </div>
      )}
      <Button type="link" onClick={showPdf}>
        *Aplican términos y condiciones
      </Button>
      <Modal
        open={pdfModalVisible}
        footer={null}
        onCancel={() => setPdfModalVisible(false)}
        width={800}
      >
        <iframe title='Términos y condiciones PDF' src={pdfUrl} width="100%" height="500px" />
      </Modal>
    </div>
  );
};

export default Agreement;